export default __webpack_public_path__ + "static/GT-America-Standard-Bold-Italic-cb2a8cbeb5dd444045d84b9e8fdb373a.ttf";